import { AnimationBaseController, IAnimationControllerConfiguration, Inject } from "@denishussar/html5-game-engine";
import { IUpdateLocale, LocalizationContents } from "../../../LocalizationContents";
import { GameModel, IScoreLogItem } from "../../../Models/GameModel";
export interface IRawControllerOptions {
    moveNumber: [number] | [number, number],
    raw: [IScoreLogItem] | [IScoreLogItem, IScoreLogItem],
    hasBg: boolean
}

export class RawController extends AnimationBaseController implements IUpdateLocale {
    $model: GameModel

    public constructor(@Inject private _options: IRawControllerOptions) {
        super("RawController");
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {

        };
    }

    protected onInitialize(): void {
        const isDouble = this._options.moveNumber.length === 2;
        const sign1 = this._options.raw[0].delta < 0 ? '-' : '+';

        this.updateLocale();
        // Выставляем значения
        this.setTextByQuery("score_total_1_text", this._options.raw[0].total.toString());
        this.setTextByQuery("score_delta_1_text", `(${sign1}${this._options.raw[0].delta})`);

        this.setTextByQuery("city_value_1_text", this._options.raw[0].city.toString());
        this.setTextByQuery("edge_value_1_text", this._options.raw[0].edge.toString());
        this.setTextByQuery("line_value_1_text", this._options.raw[0].line.toString());

        if (isDouble) {
            const sign2 = this._options.raw[1].delta < 0 ? '-' : '+';
            this.setTextByQuery("score_total_2_text", this._options.raw[1].total.toString());
            this.setTextByQuery("score_delta_2_text", `(${sign2}${this._options.raw[1].delta})`);
            this.setTextByQuery("city_value_2_text", this._options.raw[1].city.toString());
            this.setTextByQuery("edge_value_2_text", this._options.raw[1].edge.toString());
            this.setTextByQuery("line_value_2_text", this._options.raw[1].line.toString());
        }



        if (isDouble) {
            this.gotoAndStop(0);
        } else {
            this.gotoAndStop(1);
        }

        this.seVisibleByQuery("raw_background", this._options.hasBg);

    }

    updateLocale() {
        const moveStr = " " + LocalizationContents.getText("tablo_move_number");

        this.setTextByQuery("move_1_text", moveStr.replace('{{string}}', this._options.moveNumber[0].toString()).toLocaleUpperCase());
        if (this._options.moveNumber[1]) {
            this.setTextByQuery("move_2_text", moveStr.replace('{{string}}', this._options.moveNumber[1].toString()).toLocaleUpperCase());
        }
        const cityStr = LocalizationContents.getText("tablo_city").toLocaleUpperCase() + ":";
        this.setTextByQuery("city_label_1_text", cityStr);
        this.setTextByQuery("city_label_2_text", cityStr);

        const edgeStr = LocalizationContents.getText("tablo_edge").toLocaleUpperCase() + ":";
        this.setTextByQuery("edge_label_1_text", edgeStr);
        this.setTextByQuery("edge_label_2_text", edgeStr);

        const lineStr = LocalizationContents.getText("tablo_line").toLocaleUpperCase() + ":";
        this.setTextByQuery("line_label_1_text", lineStr);
        this.setTextByQuery("line_label_2_text", lineStr);

    }



}